<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

import fianlyLogo from '../../../fianly/assets/logo-fianly-small.png';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="
      globalConfig.logoThumbnail &&
      globalConfig.logoThumbnail !== '/brand-assets/logo_thumbnail.svg'
    "
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
    alt="Fianly"
  />

  <img v-else v-bind="attrs" :src="fianlyLogo" alt="Fianly" />
</template>
